import { Routes } from '@angular/router';
import { Role } from '../../core/enums/role.enum';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';

export const ajudaCustosRoutes: Routes = [
  {
    path: 'ajuda-custos',
    canActivate: [AuthGuard],
    // canActivateChild: [RoleChildGuard], // desabilitado temporariamente para testes
    data: {
      title: 'Ajuda de Custo',
      breadcrumb: [{ label: 'Ajuda de Custo', url: '/ajuda-custos' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./ajuda-custos.component').then((m) => m.AjudaCustosComponent),
        data: {
          title: 'Solicitações de Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_VISUALIZAR],
          breadcrumb: [{ label: 'Ajuda de Custo', url: '/ajuda-custos' }],
        },
      },
      {
        path: 'analisar',
        loadComponent: () =>
          import('./ajuda-custos-analise-lista/ajuda-custos-analise-lista.component').then(
            (m) => m.AjudaCustosAnaliseListaComponent,
          ),
        data: {
          title: 'Analisar Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_SOLICITACAO_LISTAR],
          breadcrumb: [
            { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
          ],
        },
      },
      {
        path: 'analisar/lote-pagamento',
        loadComponent: () =>
          import('./ajuda-custos-lote-pagamento/ajuda-custos-lote-pagamento.component').then(
            (m) => m.AjudaCustosLotePagamentoComponent,
          ),
        data: {
          title: 'Selecionar em Lote',
          roles: [Role.AJUDA_CUSTO_LOTE_SELECIONAR],
          breadcrumb: [
            { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
            { label: 'Selecionar em Lote', url: '/ajuda-custos/analisar/lote-pagamento' },
          ],
        },
      },
      {
        path: 'analisar/:id',
        loadComponent: () =>
          import('./ajuda-custos-analise-form/ajuda-custos-analise-form.component').then(
            (m) => m.AjudaCustosAnaliseFormComponent,
          ),
        data: {
          title: 'Análise da Solicitação de Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_SOLICITACAO_ANALISAR],
          breadcrumb: [
            { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
            { label: 'Análise da Solicitação' },
          ],
        },
      },
      {
        path: 'solicitar',
        loadComponent: () =>
          import('./ajuda-custos-form/ajuda-custos-form.component').then(
            (m) => m.AjudaCustosFormComponent,
          ),
        data: {
          title: 'Solicitar Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_SOLICITAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Solicitar', url: '/ajuda-custos/solicitar' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./ajuda-custos-visualizar/ajuda-custos-visualizar.component').then(
            (m) => m.AjudaCustosVisualizarComponent,
          ),
        data: {
          title: 'Visualizar Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_VISUALIZAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Visualizar', url: '/ajuda-custos/visualizar' },
          ],
          breadcrumbByRole: [
            {
              role: Role.AJUDA_CUSTO_SOLICITACAO_LISTAR,
              breadcrumb: [
                { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
                { label: 'Visualizar', url: '/ajuda-custos/visualizar' },
              ],
            },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./ajuda-custos-form/ajuda-custos-form.component').then(
            (m) => m.AjudaCustosFormComponent,
          ),
        data: {
          title: 'Editar Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_EDITAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Editar', url: '/ajuda-custos/editar' },
          ],
        },
      },
      {
        path: 'pagamento/:id',
        loadComponent: () =>
          import('./ajuda-custos-pagamento/ajuda-custos-pagamento.component').then(
            (m) => m.AjudaCustosPagamentoComponent,
          ),
        data: {
          title: 'Histórico de Pagamento',
          roles: [Role.AJUDA_CUSTO_LOTE_SELECIONAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Pagamento', url: '/ajuda-custos/pagamento' },
          ],
          breadcrumbByRole: [
            {
              role: Role.AJUDA_CUSTO_SOLICITACAO_LISTAR,
              breadcrumb: [
                { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
                { label: 'Pagamento', url: '/ajuda-custos/pagamento' },
              ],
            },
          ],
        },
      },
      {
        path: 'historico-documentos/:id',
        loadComponent: () =>
          import('./ajuda-custos-historico-documentos/ajuda-custos-historico-documentos.component').then(
            (m) => m.AjudaCustosHistoricoDocumentosComponent,
          ),
        data: {
          title: 'Histórico de Documentos',
          roles: [Role.AJUDA_CUSTO_HISTORICO_DOCUMENTOS],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Histórico de Documentos', url: '/ajuda-custos/historico-documentos' },
          ],
          breadcrumbByRole: [
            {
              role: Role.AJUDA_CUSTO_SOLICITACAO_LISTAR,
              breadcrumb: [
                { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
                { label: 'Visualizar', url: '/ajuda-custos/visualizar' },
                { label: 'Histórico de Documentos', url: '/ajuda-custos/historico-documentos' },
              ],
            },
          ],
        },
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./ajuda-custos-dashboard/ajuda-custos-dashboard.component').then((m) => m.AjudaCustosDashboardComponent),
        data: {
          title: 'Dashboard - Indicadores e Relatórios Gerenciais',
          roles: [Role.AJUDA_CUSTO_DASHBOARD_VISUALIZAR],
          breadcrumb: [
            { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
            { label: 'Dashboard', url: '/ajuda-custos/dashboard' },
          ],
        },
      },
    ],
  },
];
